module.exports = __webpack_public_path__ + "media/assets/InfoWhiteLarge-09cb2f16d24a32d09703065085545f44.svg";